
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { HopperMeasurement } from '@/models/HopperMeasurement'
import { namespace } from 'vuex-class'
import { VesselAttribute } from '@/models/Vessel'
import Testable from '@/mixins/Testable'

const Viewport = namespace('viewport')

@Component({})
export default class HopperMeasurementForm extends Mixins(Testable) {
	@Viewport.Getter('isMobile')
	isMobile

	@Prop({ required: false, default: () => new HopperMeasurement() })
	hopperMeasurement!: HopperMeasurement

	@Prop({ required: true })
	bargingLetter!: VesselAttribute

	measurementLeft1: string | null = null
	measurementLeft2: string | null = null
	measurementLeft3: string | null = null
	measurementLeft4: string | null = null
	measurementRight1: string | null = null
	measurementRight2: string | null = null
	measurementRight3: string | null = null
	measurementRight4: string | null = null

	get measurements(): Array<number> {
		return [
			this.measurementLeft1,
			this.measurementLeft2,
			this.measurementLeft3,
			this.measurementLeft4,
			this.measurementRight1,
			this.measurementRight2,
			this.measurementRight3,
			this.measurementRight4
		]
			.filter((val) => val !== null)
			.map((val) => Number.parseInt(val + ''))
	}

	get averageCm(): number {
		return this.measurements.reduce((sum, val) => sum + val, 0) / (this.measurements.length || 1)
	}

	get calculatedVolume(): number {
		const bargingLetterValue = (this.bargingLetter.value ?? {}) as {
			data?: Array<Array<number>>
		}
		return (bargingLetterValue.data ?? []).reduce((prev, curr) => {
			return Math.abs(curr[0] - this.averageCm) < Math.abs(prev[0] - this.averageCm) ? curr : prev
		})[1]
	}

	@Watch('measurementLeft1')
	@Watch('measurementLeft2')
	@Watch('measurementLeft3')
	@Watch('measurementLeft4')
	@Watch('measurementRight1')
	@Watch('measurementRight2')
	@Watch('measurementRight3')
	@Watch('measurementRight4')
	notifyCounters(value) {
		this.$emit('update:total')
	}
}
